export class MovimientoInventarioActualizado {
  constructor(movimiento) {
    this.eventName = "MovimientoInventarioActualizado";
    this.ocurrio = new Date();
    this.data = movimiento;
  }
}
